module.exports = __webpack_public_path__ + "src/assets/games/3/reqiqiu.png";